import { Button, useNotify } from "react-admin";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { settings } from "app";
import { activityRequests } from "api/activityApi";
import { getFileFromUrl } from "server/components/DownloadFile";

const DownloadResultsTemplate = () => {
  const notify = useNotify();
  const downloadTemplate = async () => {
    const fileName = "import_entry_test_results_template.xlsx";
    await getFileFromUrl(
      `${settings.gatewayApi}/${activityRequests.getEntryTestResultsTemplate()}`,
      fileName,
      notify,
    );
  };
  return (
    <Button
      startIcon={<FileDownloadIcon />}
      label="Изтегли"
      onClick={downloadTemplate}
    />
  );
};

export default DownloadResultsTemplate;
